import gql from 'graphql-tag';

export const WORKSPACE_INVITE_INFO = gql`
  query WorkspaceInviteInfo($invitationKey: String!) {
    workspaceInviteInfo(invitationKey: $invitationKey) {
      auth0UserExists
    }
  }
`;
